(function () {
  var PINK_VARIANT_IDS = {
    '49247614009561': true,
  };
  var FILE_BASE = 'https://th.shokz.com/cdn/shop/files/';
  var FILE_V = '1789617237';
  var ORIG_BOX_TEXT =
    'หูฟังไร้สาย OpenDots 2 *2 <br />เคสชาร์จ OpenDots 2 *1 <br />สายชาร์จ USB-C *1<br />คู่มือการใช้งาน *1 <br />เอกสารข้อกำหนดทางกฎหมาย *1<br />บัตรรับประกัน *1<br />บัตรแนะนำการใช้แอป *1';
  var PINK_BOX_TEXT =
    'หูฟังไร้สาย OpenDots 2 *2 <br />ชาร์มแมวเหมียว *1 <br />โฟโต้การ์ด Jane Yeh *1 <br />เคสชาร์จ OpenDots 2 *1 <br />สายชาร์จ USB-C *1 <br />คู่มือการใช้งาน *1 <br />เอกสารข้อกำหนดทางกฎหมาย *1 <br />บัตรรับประกัน *1 <br />บัตรแนะนำการใช้แอป *1';

  function fileUrl(name) {
    return FILE_BASE + name;
  }

  function janeFile(name) {
    return FILE_BASE + name + '?v=' + FILE_V;
  }

  function isPinkVariant(id, title) {
    if (PINK_VARIANT_IDS[String(id)]) return true;
    var hay = String(title || '').toLowerCase();
    return hay.indexOf('purrfect') !== -1 || hay.indexOf('pink') !== -1 || hay.indexOf('ชมพู') !== -1;
  }

  function setImg(img, url) {
    if (!url || !img) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function swapSlot(el, pcUrl, mbUrl) {
    if (!el) return;
    var imgs = el.querySelectorAll('img');
    imgs.forEach(function (img) {
      var inMobile =
        el.closest('.od2-bento-mobile') ||
        el.closest('.opendots2-additional-mb') ||
        img.classList.contains('hide-pc');
      setImg(img, inMobile ? mbUrl || pcUrl : pcUrl || mbUrl);
    });
  }

  function applyPower(isPink) {
    var el = document.querySelector('.opendots-two-power-distance');
    if (!el) return;
    var desk = isPink ? janeFile('opendots-two-image-10-jane-pc.webp') : fileUrl('opendots-two-image-11-pc.webp');
    var mob = isPink ? janeFile('opendots-two-image-10-jane-mb.webp') : fileUrl('opendots-two-image-11-m.webp');
    el.classList.toggle('is-opendots2-pink', isPink);
    el.style.setProperty('--od-pd-bg-desk', "url('" + desk + "')");
    el.style.setProperty('--od-pd-bg-mob', "url('" + mob + "')");
  }

  function applyBoxText(isPink) {
    var textEl = document.querySelector('.section-product-what-in-box-tnk .item-4 .text');
    if (!textEl) return;
    textEl.innerHTML = isPink ? PINK_BOX_TEXT : ORIG_BOX_TEXT;
  }

  function applyEdition(isPink) {
    var root = document.querySelector('.product-opendots-two');
    if (root) root.classList.toggle('is-opendots2-pink', isPink);

    function pair(origPc, origMb, janePc, janeMb) {
      if (isPink) return [janeFile(janePc), janeFile(janeMb || janePc)];
      return [fileUrl(origPc), fileUrl(origMb || origPc)];
    }

    var videoMap = {
      'item-1': pair('opendots-two-image-1-pc.webp', 'opendots-two-image-1-m.webp', 'opendots-two-image-1-jane-pc.webp', 'opendots-two-image-1-jane-mb.webp'),
      'item-2': pair('opendots-two-image-4-pc.webp', 'opendots-two-image-4-m.webp', 'opendots-two-image-4-jane-pc.webp', 'opendots-two-image-4-jane-mb.webp'),
      'item-3': pair('opendots-two-image-5-pc.webp', 'opendots-two-image-5-m.webp', 'opendots-two-image-5-jane-pc.webp', 'opendots-two-image-5-jane-mb.webp'),
      'item-4': pair('opendots-two-image-2-pc.webp', 'opendots-two-image-2-m.webp', 'opendots-two-image-2-jane-pc.webp', 'opendots-two-image-2-jane-mb.webp'),
      'item-5': pair('opendots-two-image-3-pc.webp', 'opendots-two-image-3-m.webp', 'opendots-two-image-3-jane-pc.webp', 'opendots-two-image-3-jane-mb.webp'),
      'item-6': pair('opendots-two-image-6-pc.webp', 'opendots-two-image-6-m.webp', 'opendots-two-image-6-jane-pc.webp', 'opendots-two-image-6-jane-mb.webp'),
      'item-7': pair('opendots-two-image-7-pc.webp', 'opendots-two-image-7-m.webp', 'opendots-two-image-7-jane-pc.webp', 'opendots-two-image-7-jane-mb.webp'),
    };
    Object.keys(videoMap).forEach(function (cls) {
      document.querySelectorAll('.section-opendots-two-video-img .' + cls).forEach(function (el) {
        swapSlot(el, videoMap[cls][0], videoMap[cls][1]);
      });
    });

    var soundCols = document.querySelectorAll('.opendots-two-larger-than-life-sound__col');
    var sound1 = pair('opendots-two-image-8-pc.webp', 'opendots-two-image-8-m.webp', 'opendots-two-image-8-jane-pc.webp', 'opendots-two-image-8-jane-mb.webp');
    var sound2 = pair('opendots-two-image-9-pc.webp', 'opendots-two-image-9-m.webp', 'opendots-two-image-9-jane-pc.webp', 'opendots-two-image-9-jane-mb.webp');
    if (soundCols[0]) swapSlot(soundCols[0], sound1[0], sound1[1]);
    if (soundCols[1]) swapSlot(soundCols[1], sound2[0], sound2[1]);

    applyPower(isPink);

    var boxItems = document.querySelectorAll('.section-product-what-in-box-tnk .item');
    var boxPairs = [
      pair('opendots-two-image-12-pc.webp', 'opendots-two-image-12-pc.webp', 'opendots-two-image-11-jane-pc.webp', 'opendots-two-image-11-jane-mb.webp'),
      pair('opendots-two-image-13-pc.webp', 'opendots-two-image-13-pc.webp', 'opendots-two-image-12-jane-pc.webp', 'opendots-two-image-12-jane-pc.webp'),
      pair('opendots-two-image-14-pc.webp', 'opendots-two-image-14-pc.webp', 'opendots-two-image-13-jane-pc.webp', 'opendots-two-image-13-jane-pc.webp'),
    ];
    boxPairs.forEach(function (urls, i) {
      if (boxItems[i]) swapSlot(boxItems[i], urls[0], urls[1]);
    });
    applyBoxText(isPink);

    var featPc = isPink
      ? janeFile('opendots-two-image-14-jane-pc.webp')
      : 'https://cdn.shopify.com/s/files/1/0074/1890/4612/files/opendots-two-image-15-pc.webp?v=1779076032';
    var featMb = isPink
      ? janeFile('opendots-two-image-14-jane-mb.webp')
      : 'https://cdn.shopify.com/s/files/1/0074/1890/4612/files/opendots-two-image-15-m.webp?v=1778727260';
    document.querySelectorAll('.opendots2-additional-pc').forEach(function (el) {
      swapSlot(el, featPc, featPc);
    });
    document.querySelectorAll('.opendots2-additional-mb').forEach(function (el) {
      swapSlot(el, featMb, featMb);
    });
  }

  function readActiveVariant() {
    var active = document.querySelector('.product-opendots-two .options-color-wrapper.active');
    if (active) {
      return {
        id: active.getAttribute('data-var_id'),
        title: active.getAttribute('data-title') || active.getAttribute('data-option1') || '',
      };
    }
    var cfg = window.opendots2PinkEdition || {};
    return { id: cfg.currentId, title: cfg.currentTitle };
  }

  function syncFromActive() {
    var v = readActiveVariant();
    applyEdition(isPinkVariant(v.id, v.title));
  }

  function bind() {
    document.addEventListener(
      'click',
      function (event) {
        var wrap = event.target.closest && event.target.closest('.options-color-wrapper');
        if (!wrap || !document.querySelector('.product-opendots-two')) return;
        applyEdition(
          isPinkVariant(
            wrap.getAttribute('data-var_id'),
            wrap.getAttribute('data-title') || wrap.getAttribute('data-option1') || ''
          )
        );
      },
      true
    );
    window.addEventListener('popstate', syncFromActive);
    syncFromActive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
